// extracted by mini-css-extract-plugin
module.exports = {"radio":"TariffCalculatorCustomerType_radio_3Ksli"};